class ProductDetails extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.dropdownButtons = this.querySelectorAll("[data-product-detail-button]");
    this.handleClick = this.handleClick.bind(this);

    this.dropdownButtons.forEach((button) => {
      button.addEventListener('click', this.handleClick);
    })
  }

  disconnectedCallback() {
    this.dropdownButtons.forEach((button) => {
      button.removeEventListener('click', this.handleClick);
    })
  }

  handleClick(e) {
    const dropdown = e.target.closest("[data-product-detail]");
    dropdown.dataset.productDetail === "close" ? dropdown.dataset.productDetail = "open" : dropdown.dataset.productDetail = "close";
  }
}

customElements.define('product-details', ProductDetails);
